module.exports = __webpack_public_path__ + "img/electromenager-ou-multimedia.65db935.svg";